import { Injectable } from '@angular/core';
import { combineLatest, map, Observable, of } from 'rxjs';
import { IAbstractPresenter } from '@core/interfaces';
import { IScreenLoadingComponent, IScreenLoadingPresenter } from './interfaces';

@Injectable({
	providedIn: 'root',
})
export class ScreenLoadingPresenter
	extends IAbstractPresenter<IScreenLoadingComponent>
	implements IScreenLoadingPresenter
{
	loading$: Observable<boolean> = of(false);
	loadingList$: Observable<boolean>[] = [];

	dispatchActions(): void {}

	suscribeObservers(): void {
		this.isLoading();
	}

	isLoading(): void {
		if (this.view.loadingList$ && this.view.loadingList$.length > 0) {
			this.view.combinedLoading$ = combineLatest(this.view.loadingList$).pipe(map(values => values.some(v => v)));
		} else {
			this.view.combinedLoading$ = this.view.loading$;
		}
	}
}
